import { useState, FormEvent, ReactNode } from "react";
import { Link } from "react-router-dom";

const FORM_URL = "https://readdy.ai/api/form/d6vtna7b245v7h34osq0";

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const msg = (form.elements.namedItem("mensagem") as HTMLTextAreaElement)?.value || "";
    if (msg.length > 500) return;

    setLoading(true);
    const data = new FormData(form);
    const body = new URLSearchParams();
    data.forEach((value, key) => body.append(key, value.toString()));

    try {
      await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
      form.reset();
      setCharCount(0);
    } catch {
      // silently handle
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full px-4 py-2.5 bg-white text-sm text-[#000000] placeholder-[#000000]/30 rounded-md transition-colors outline-none focus:ring-2 focus:ring-[#62A9E0]/30 focus:border-[#62A9E0]";
  const inputStyle = { border: '1px solid rgba(0,0,0,0.12)' };

  return (
    <section id="contato" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#4C86C2' }}>
            <div className="w-6 h-px" style={{ background: 'linear-gradient(to right, #62A9E0, #4C86C2)' }}></div>
            Contato
            <div className="w-6 h-px" style={{ background: 'linear-gradient(to right, #62A9E0, #4C86C2)' }}></div>
          </div>
          <h2 className="text-4xl font-black text-[#000000] mb-4">
            Fale com nossa <span className="solus-gradient-text">equipe</span>
          </h2>
          <p className="text-[#000000]/55 max-w-xl mx-auto text-sm">
            Nossa equipe de consultores está aguardando seu contato com as melhores soluções.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Form */}
          <div>
            {submitted ? (
              <div className="flex flex-col items-center justify-center h-full py-16 text-center">
                <div
                  className="w-16 h-16 flex items-center justify-center rounded-full mb-4"
                  style={{ background: 'rgba(98,169,224,0.12)', color: '#4C86C2' }}
                >
                  <i className="ri-check-line text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#000000] mb-2">Mensagem enviada!</h3>
                <p className="text-sm text-[#000000]/55">Em breve nossa equipe entrará em contato com você.</p>
                <button
                  onClick={() => setSubmitted(false)}
                  className="mt-6 text-sm font-medium hover:underline cursor-pointer"
                  style={{ color: '#4C86C2' }}
                >
                  Enviar outra mensagem
                </button>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-[#000000] mb-1.5">Nome *</label>
                    <input
                      type="text"
                      name="nome"
                      required
                      placeholder="Seu nome completo"
                      className={inputClass}
                      style={inputStyle}
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-[#000000] mb-1.5">Empresa</label>
                    <input
                      type="text"
                      name="empresa"
                      placeholder="Nome da empresa"
                      className={inputClass}
                      style={inputStyle}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-[#000000] mb-1.5">E-mail *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="seu@email.com.br"
                    className={inputClass}
                    style={inputStyle}
                  />
                </div>

                <div>
                  <label className="block text-xs font-semibold text-[#000000] mb-1.5">Telefone</label>
                  <input
                    type="tel"
                    name="telefone"
                    placeholder="(91) 00000-0000"
                    className={inputClass}
                    style={inputStyle}
                  />
                </div>

                <div>
                  <label className="block text-xs font-semibold text-[#000000] mb-1.5">Assunto</label>
                  <select
                    name="assunto"
                    className={inputClass}
                    style={{ ...inputStyle, background: '#ffffff' }}
                  >
                    <option value="">Selecione o assunto</option>
                    <option value="Infraestrutura, Servidores e HCI">Infraestrutura, Servidores e HCI</option>
                    <option value="Storage e Proteção de Dados">Storage e Proteção de Dados</option>
                    <option value="Backup e Recuperação">Backup e Recuperação</option>
                    <option value="Cloud Pública e Cloud Privada">Cloud Pública e Cloud Privada</option>
                    <option value="Cibersegurança e LGPD">Cibersegurança e LGPD</option>
                    <option value="Conectividade e Redes">Conectividade e Redes</option>
                    <option value="NG-SOC e Resposta a Incidentes">NG-SOC e Resposta a Incidentes</option>
                    <option value="Suporte, Service Desk e NOC">Suporte, Service Desk e NOC</option>
                    <option value="Inteligência Artificial">Inteligência Artificial</option>
                    <option value="Soluções Personalizadas">Soluções Personalizadas</option>
                    <option value="Licitação">Licitação</option>
                    <option value="Outros">Outros</option>
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-[#000000] mb-1.5">
                    Mensagem *{" "}
                    <span className="font-normal ml-1" style={{ color: '#62A9E0' }}>
                      {charCount}/500
                    </span>
                  </label>
                  <textarea
                    name="mensagem"
                    required
                    maxLength={500}
                    rows={4}
                    onChange={(e) => setCharCount(e.target.value.length)}
                    placeholder="Descreva sua necessidade..."
                    className={`${inputClass} resize-none`}
                    style={inputStyle}
                  />
                </div>

                {/* LGPD Consent */}
                <div className="flex items-start gap-2.5 p-3 rounded-lg" style={{ background: "rgba(98,169,224,0.05)", border: "1px solid rgba(98,169,224,0.15)" }}>
                  <input
                    type="checkbox"
                    name="lgpd_consentimento"
                    id="lgpd_consentimento"
                    required
                    className="mt-0.5 shrink-0 cursor-pointer accent-[#4C86C2]"
                    style={{ width: "14px", height: "14px" }}
                  />
                  <label htmlFor="lgpd_consentimento" className="text-xs text-[#000000]/60 leading-relaxed cursor-pointer">
                    Concordo com o tratamento dos meus dados pessoais para fins de atendimento desta solicitação, conforme a{" "}
                    <Link to="/politica-de-privacidade" className="font-medium hover:underline" style={{ color: "#4C86C2" }} target="_blank" rel="noopener noreferrer">
                      Política de Privacidade
                    </Link>{" "}
                    da Solus IT, em conformidade com a LGPD (Lei nº 13.709/2018). *
                  </label>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 solus-btn-primary font-semibold rounded-md text-sm cursor-pointer whitespace-nowrap disabled:opacity-60"
                >
                  {loading ? "Enviando..." : "Enviar mensagem"}
                </button>
              </form>
            )}

            {/* Licitações */}
            <div
              className="mt-6 p-4 rounded-lg flex items-center gap-3"
              style={{ background: 'rgba(98,169,224,0.06)', border: '1px solid rgba(98,169,224,0.2)' }}
            >
              <div className="w-8 h-8 flex items-center justify-center" style={{ color: '#62A9E0' }}>
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs font-bold text-[#000000]">Contato para licitações</div>
                <a href="mailto:licitacao@solus-it.com.br" className="text-xs hover:underline" style={{ color: '#4C86C2' }}>
                  licitacao@solus-it.com.br
                </a>
              </div>
            </div>
          </div>

          {/* Map + Info */}
          <div className="flex flex-col gap-6">
            {/* Map */}
            <div className="rounded-lg overflow-hidden flex-1 min-h-64" style={{ border: '1px solid rgba(98,169,224,0.2)' }}>
              <iframe
                title="Endereços Comerciais Solus IT"
                src="https://maps.google.com/maps?q=Rua+Arcipreste+Manoel+Teodoro,+150,+Batista+Campos,+Belém,+PA,+66023-700&t=&z=17&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: "260px" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            {/* Contact Info */}
            <div className="grid grid-cols-2 gap-4">
              {(
                [
                  { icon: "ri-phone-line", label: "Telefones", value: "(91) 3241-5792 | (11) 99184-1569" },
                  { icon: "ri-mail-line", label: "E-mail comercial", value: "comercial@solus-it.com.br" },
                  { icon: "ri-time-line", label: "Horário", value: "Seg–Sex: 8h às 18h" },
                  {
                    icon: "ri-map-pin-line",
                    label: "Endereços Comerciais",
                    value: (
                      <>
                        R. Arcipreste Manoel Teodoro, 150 — 19º and., Belém/PA
                        <br />
                        Av. Paulista, 302, São Paulo/SP
                      </>
                    ),
                  },
                ] as { icon: string; label: string; value: ReactNode }[]
              ).map((info) => (
                <div
                  key={info.label}
                  className="rounded-lg p-4"
                  style={{ background: 'rgba(98,169,224,0.05)', border: '1px solid rgba(98,169,224,0.15)' }}
                >
                  <div className="w-8 h-8 flex items-center justify-center mb-2" style={{ color: '#62A9E0' }}>
                    <i className={`${info.icon} text-lg`}></i>
                  </div>
                  <div className="text-xs font-bold text-[#000000]">{info.label}</div>
                  <div className="text-xs text-[#000000]/55 mt-0.5">{info.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
